import { PipeTransform, Pipe } from '@angular/core';
import { hasPermissionTransform, hasAnyPermissionTransform } from './util';
import { permissionConstant } from './constant';
import { helpers } from '../utils';

export class GlobalBasePrivilegePipe implements PipeTransform {
    protected moduleName: string;

    constructor(moduleName: string) {
        this.moduleName = moduleName;
    }

    transform(value: any, definitionName: string | string[] | any): Boolean {
        if (value === undefined) {
            return false;
        }
        // 10110111
        const maskValue = helpers.isObject(value) ? value.value : value;
        if (helpers.isArray(definitionName)) {
            return hasAnyPermissionTransform(
                maskValue,
                permissionConstant.privileges.global[this.moduleName],
                definitionName
            );
        } else {
            return hasPermissionTransform(
                maskValue,
                permissionConstant.privileges.global[this.moduleName],
                definitionName
            );
        }
    }
}

export class ModuleBasePrivilegePipe implements PipeTransform {
    protected moduleName: string;

    constructor(moduleName: string) {
        this.moduleName = moduleName;
    }

    transform(value: any, definitionName: string | string[] | any): Boolean {
        if (value === undefined) {
            return false;
        }
        const maskValue = helpers.isObject(value) ? value.value : value;
        if (helpers.isArray(definitionName)) {
            return hasAnyPermissionTransform(
                maskValue,
                permissionConstant.privileges.modules[this.moduleName],
                definitionName
            );
        } else {
            return hasPermissionTransform(
                maskValue,
                permissionConstant.privileges.modules[this.moduleName],
                definitionName
            );
        }
    }
}
